import React from 'react';
import { getImageUrl } from 'utils';
interface LogoProps {
    path: string;
    name: string;
    active?: string;
    nameLength?:number;
}

const Logo: React.FC<LogoProps> = ({ path, name="", active="", nameLength=2 }) => {
    return (
        <>{
            path ? (
                <div key={name} className="logo-icon-name-wrapper carrier-comparisionImg w-auto d-flex align-items-center border-0 border-right-green">
                    <div
                        className={`${active}`}
                    />
                    <img
                        src={path && getImageUrl(path)}
                        alt="logo"
                        className=" profileimgWrap"
                    />
                </div>
            ) : (
                <div key={name} className="logo-icon-name-wrapper border-0 border-right-green me-0 d-flex align-items-center p-2">
                    <div className={active}/>
                    <div className='imgTxtWrap'>
                        <span className="logo-icon-name ms-2">
                            {name?.substring(0, nameLength)}
                        </span>
                    </div>
                   
                </div>
            )
        }

        </>
    );
};

export default Logo;

